<template>
  <div class="snap-container">
    <section class="snap-section1" id="slide-1">
      <KhmerVersion />
    </section>
    <section class="snap-section1">
      <EnglishVersion />
    </section>
    <section class="snap-section1" id="slide-2">
      <VideoSection />
    </section>
    <section class="snap-section">
      <PhotoGallery />
    </section>
    <section class="snap-section1" id="slide-3">
      <WeddingMap />
    </section>
    <section class="snap-section" id="slide-4">
      <TimeSection />
    </section>
    <section class="snap-section" >
      <ThankSection />
    </section>
    <section class="snap-section">
      <GreetingSection />
    </section>
    <BottomNav />
  </div>
</template>

<script>
import KhmerVersion from "@/components/KhmerVersion.vue";
import EnglishVersion from "@/components/EnglishVersion.vue";
import VideoSection from "@/components/VideoSection.vue";
import PhotoGallery from "@/components/PhotoGallery.vue";
import WeddingMap from "@/components/WeddingMap.vue";
import TimeSection from "@/components/TimeSection.vue";
import ThankSection from "@/components/ThankSection.vue";
import GreetingSection from "@/components/GreetingSection.vue";
import BottomNav from "@/components/BottomNav.vue";

export default {
  components: {
    KhmerVersion,
    EnglishVersion,
    VideoSection,
    PhotoGallery,
    WeddingMap,
    TimeSection,
    ThankSection,
    GreetingSection,
    BottomNav
  }
};
</script>
